<div class="hidden-from-ssr" {style}>
  <slot></slot>
</div>
<script>
  export default {
    computed: {
      style ({ $isUserLoggedIn }) {
        return process.env.BROWSER && !$isUserLoggedIn ? '' : 'opacity: 0'
      }
    }
  }
</script>
